import { RequirementType } from "@wingspanhq/payments/dist/interfaces/requirement";

import {
  RequirementDefinitionSharedFileFormValues,
  RequirementDefinitionSignatureFormValues,
  RequirementDefinitionStandardBackgroundCheckFormValues
} from "../../../../types";
import { FlowCreateNewVersionSettingsData } from "../../types";
import { getBackgroundCheckSettings } from "./getBackgroundCheckSettings";
import { getInsuranceCoverageSettings } from "./getInsuranceCoverageSettings";
import { getSharedFileSettings } from "./getSharedFileSettings";
import { getSignatureSettings } from "./getSignatureSettings";

export const getRequirementSettingsItems = (
  requirementType: RequirementType,
  settings: FlowCreateNewVersionSettingsData
): string[] => {
  switch (requirementType) {
    case RequirementType.Signature:
      return getSignatureSettings(
        settings as Partial<
          Pick<RequirementDefinitionSignatureFormValues, "requiredSignatures">
        >
      );
    case RequirementType.SharedFile:
      return getSharedFileSettings(
        settings as Partial<RequirementDefinitionSharedFileFormValues>
      );
    case RequirementType.BackgroundCheck:
      return getBackgroundCheckSettings(
        settings as Partial<RequirementDefinitionStandardBackgroundCheckFormValues>
      );
    case RequirementType.InsuranceCoverage:
      return getInsuranceCoverageSettings(settings);
    case RequirementType.IdentityVerification:
      return ["Document & biometric verification"];
    default:
      return ["—"];
  }
};
